<template>
  <div class="textarea-wrapper">
    <textarea-autosize
      :placeholder="trans('Maximum :number characters', { 'number': this.maxLength })"
      :value="value"
      @input="inputHandler"
      :min-height="30"
      :max-height="200"
      :max-length="maxLength"
      class="form-control w-100"
    />

    <div class="chars-remaining">
      {{ charsCount }}&nbsp;/&nbsp;{{ maxLength }}
    </div>

    <div class="progressbar-wrapper">
      <div class="progressbar" :style="`width: ${this.progress}%`"></div>
      <div class="progressbar-overlay"></div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import VueTextareaAutosize from 'vue-textarea-autosize';

  Vue.use(VueTextareaAutosize);

  export default {
    name: "CustomTextarea",

    props: {
      value: {
        type: String,
        default: '',
      },

      maxLength: {
        type: Number,
        default: 2000,
      }
    },

    mounted() {
      this.$el.querySelector('textarea').maxLength = this.maxLength;
    },

    computed: {
      charsCount() {
        return this.value && this.value.length ? this.value.length : 0;
      },

      charsRemaining() {
        return this.maxLength - this.charsCount;
      },

      progress() {
        return (this.maxLength - this.charsRemaining) / this.maxLength * 100;
      }
    },

    methods: {
      inputHandler(val) {
        if (val.length <= this.maxLength) {
          this.$emit('input', val);
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../../sass/colors';
  @import '../../../../sass/vue-select';

  .textarea-wrapper {
    position: relative;
    display: flex;
    flex-flow: column;

    .form-control {
      border-bottom: none;
    }

    .form-control {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }

    .chars-remaining {
      position: absolute;
      bottom: -2px;
      right: 6px;
      font-size: .5rem;
    }
  }

  .progressbar-wrapper {
    height: .5rem;
    background-color: $textPrimaryGray;
    border-bottom-right-radius: .5rem;
    border-bottom-left-radius: .5rem;
    position: relative;
    overflow: hidden;

    .progressbar-overlay {
      border-bottom-left-radius: 1rem;
      border-bottom-right-radius: 1rem;
      box-sizing: border-box;
      background: #ffffff;
      width: 100%;
      height: 0.5rem;
      top: -0.2rem;
      position: absolute;
    }

    .progressbar {
      background-color: $primary;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      transition: 500ms;
    }
  }
</style>
